export const PaymentMethods = [
    {
        name: 'IntellectMoney',
        value: 'intellectmoney',
        method: 'СБП',
        img: '/images/paymentMethods/intellectmoney.png',
        public: false
    },
    {
        name: 'Lava',
        value: 'lava',
        method: 'СБП/Карта',
        img: '/images/paymentMethods/lava.png',
        public: false
    },
    {
        name: 'FreeKassa',
        value: 'freekassa',
        method: 'Карта',
        img: '/images/paymentMethods/freekassa.png',
        public: false
    },
    {
        name: 'BlackRabbit',
        value: 'balckrabbit',
        method: 'Карта',
        img: '/images/paymentMethods/blackrabbit.png',
        public: false
    },
    {
        name: 'Unitpay',
        value: 'unitpay',
        method: 'СБП',
        img: '/images/paymentMethods/unitpay.png',
        public: true
    },
    {
        name: 'Urlpay',
        value: 'urlpay',
        method: 'СБП',
        img: '/images/paymentMethods/urlpay.png',
        public: true
    },
    {
        name: 'Antilopay',
        value: 'antilopay',
        method: 'СБП',
        img: '/images/paymentMethods/antilopay.png',
        public: true
    },
    {
        name: 'USDT',
        value: 'usdt',
        method: 'USDT',
        img: '/images/paymentMethods/usdt.png',
        public: false
    }
]